if(!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', 
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.initProductRecommendations();
      }

      get url() {
        return this.dataset.url;
      }

      async initProductRecommendations() {
        if (!this.url) return;
        const response  = await fetch(this.url);
        const result = await response.text();
        const parser = new DOMParser().parseFromString(result, 'text/html');
        const recommendations = parser.querySelector('product-recommendations');
        if(!recommendations) return;
        this.innerHTML = recommendations.innerHTML;
      }
    }
  )
}